import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeSyncDefinitionComponent } from './component/time-sync-definition.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule, ServiceResponseModule } from '@sdbn/common';

import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TimeSyncDefinitionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,

    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule
  ]
})
export class TimeSyncDefinitionModule { }
